import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap'

export default props => {
  const itemsLength = props.breadcrumbItems.length

  return (
    <Row>
      <Col xs={12}>
        <div className="d-flex align-items-center justify-content-between mb-4 mt-2">
          <h3 style={{ margin: 0, padding: 0 }}>{props.title}</h3>
          <div className="page-title-right">
            <Breadcrumb listClassName="m-0 p-0">
              {
                props.breadcrumbItems.map((item, key) => (key + 1 === itemsLength
                  ? (
                    <BreadcrumbItem key={item.title} active>
                      {item.title}
                    </BreadcrumbItem>
                  )
                  : (
                    <BreadcrumbItem key={item.title}>
                      <Link to={item.link}>{item.title}</Link>
                    </BreadcrumbItem>
                  )))
              }
            </Breadcrumb>
          </div>
        </div>
      </Col>
    </Row>
  )
}
